import request from '@/network/axios'

export function getSectionWithChapter(params) {
  return request({
    method: 'GET',
    url: '/course/sectionWithChapter',
    params: params,
  })
}
